export default {
  namespaced: true,
  state: {
    step: 1,
    contactsToImport: [],
    addressesToImport: [],
    contactsTags: [],
    importResults: {
      success: 0,
      errors: 0,
    },
    contactsFields: [],
    fieldsMatch: {},
  },
  mutations: {
    setFieldsMatch(state, matchedFields) {
      state.fieldsMatch = matchedFields;
    },
    setStep(state, step) {
      state.step = step;
    },
    setContactsToImport(state, contacts) {
      state.contactsToImport = contacts;
    },
    setAddressesToImport(state, addresses) {
      state.addressesToImport = addresses;
    },
    setContactsTags(state, tags) {
      state.contactsTags = tags;
    },
    clearImportResults(state) {
      state.importResults = { success: 0, errors: 0, failedRecords: 0 };
    },
    setImportResults(state, { success, errors, failedRecords }) {
      state.importResults = { success, errors, failedRecords };
    },
    clearImportProcess(state) {
      state.contactsTags = [];
      state.addressesToImport = [];
      state.contactsToImport = [];
      state.step = 1;
    },
    setContactsFields(state, fields) {
      state.contactsFields = fields;
    }
  },
  actions: {
    setFieldsMatch({ commit }, matchedFields) {
      commit('setFieldsMatch', matchedFields);
    },
    setStep({ commit }, step) {
      commit('setStep', step);
    },
    setContactsToImport({ commit }, contacts) {
      commit('setContactsToImport', contacts);
    },
    setAddressesToImport({ commit }, addresses) {
      commit('setAddressesToImport', addresses);
    },
    setContactsTags({ commit }, tags) {
      commit('setContactsTags', tags);
    },
    clearImportResults({ commit }) {
      commit('clearImportResults');
    },
    setImportResults({ commit }, payload) {
      commit('setImportResults', payload);
    },
    setContactsFields({ commit }, fields) {
      commit('setContactsFields', fields);
    }
  },
};
